import { render, staticRenderFns } from "./withdrawalFailed.vue?vue&type=template&id=b6ed089c&scoped=true"
import script from "./withdrawalFailed.vue?vue&type=script&lang=js"
export * from "./withdrawalFailed.vue?vue&type=script&lang=js"
import style0 from "./withdrawalFailed.vue?vue&type=style&index=0&id=b6ed089c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ed089c",
  null
  
)

export default component.exports